<div class="container flex flex-col items-center gap-4">
  <img src="/assets/imgs/not-found.svg" alt="Pas trouvé" />
  <div class="legend flex flex-col items-center">
    <span class="legend-title title-medium-semibold">Oops, vous n'avez pas le droit d'accéder à cette page...</span>
    <span class="legend-subtitle paragraph-medium-medium"
      >Il semblerait que vous cherchiez à accéder à une page sans en avoir l'autorisation. Rendez-vous à la page
      d’accueil pour reprendre votre navigation et votre parcours dans l’application Le Compas !</span
    >
  </div>
  <a [routerLink]="['/']" hlmBtn>Retourner à la page d'accueil</a>
</div>
